import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { autoCompleteDelay } from "../../config";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, DropDownData, FetchAutoCompleteData, FindTranslatedKey, convertThreeDecimalsOnValue, convertToNumber, convertTwoDecimalsOnValue, handleDateChange } from "../CommonComponents/CustomHooks";
import { AutoCompleteBox, DateBox, FormButton, InputBox, SelectInputBox } from "../CommonComponents/InputBox";
import { GetSession } from "../../EnvConfig/env_config";
import { IoAddCircleSharp } from "react-icons/io5";
import Modal from 'react-bootstrap/Modal';
import { RiAddBoxFill } from "react-icons/ri";
import { GrPowerReset } from "react-icons/gr";

const PacketBooking = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const inputrefs = useRef([]);
    const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
    const searchParams = new URLSearchParams(location.search);
    const awbNo = searchParams.get('AwbNo');
    const PageType = searchParams.get('PageType');
    const [remainingClicks, setRemainingClicks] = useState(0);
    const [identicalShow, setidenticalShow] = useState(false)
    const Hidesfield = true
    const [remainingDescClicks, setRemainingDescClicks] = useState(0);
    const Branchcode = GetSession('cookies', 'branchCode');
    const bcode = Branchcode?.split(" : ")[0] || ''
    const selectedDate2 = new Date();
    const dateArr2 = selectedDate2.toDateString().split(" ");
    const formattedDate1 = `${dateArr2[2]}-${dateArr2[1]}-${dateArr2[3]}`;
    const handleModalIdenticalShowClose = () => setidenticalShow(false);
    const handleOpenIdentical = async (key) => {
        await setidenticalShow(true)
    };
    const [identicalForm, setIdenticalForm] = useState({
        "identicalLenght": '',
        "identicalWidht": '',
        "identicalHeight": '',
        "identicalVol": '',
        "identicalpieces": '',

    })
    const handleIdenticalReset = () => {
        setIdenticalForm({
            "identicalLenght": '',
            "identicalWidht": '',
            "identicalHeight": '',
            "identicalVol": '',
            "identicalpieces": '',
        })
    }
    const calculateVolWeight = (length, width, height,) => {
        if (!length || !width || !height) return '';
        return ((length * width * height) / Number(formData.divisor)).toFixed(3);
    };

    const handleChangeIdentical = (field, value) => {
        const updatedForm = { ...identicalForm, [field]: value };
        if (['identicalLenght', 'identicalWidht', 'identicalHeight'].includes(field)) {
            const { identicalLenght, identicalWidht, identicalHeight } = updatedForm;
            updatedForm.identicalVol = calculateVolWeight(
                Number(identicalLenght),
                Number(identicalWidht),
                Number(identicalHeight)
            );
        }
        setIdenticalForm(updatedForm);
    };
    const handleIdentical = () => {
        const arr = Number(identicalForm.identicalpieces);
        const totalPacket = Number(formData.totalPacket);


        if (totalPacket === 0) {
            NotificationSound('ERROR', 'Please Filled pieces!.', '', '', '');
            return;
        }
        if (arr > totalPacket) {
            NotificationSound('ERROR', 'You have selected more pieces than available!.', '', '', '');
            return;
        }
        const length = identicalForm.identicalLenght;
        const breadth = identicalForm.identicalWidht;
        const height = identicalForm.identicalHeight;
        const volWeight = identicalForm.identicalVol;
        fillInitialData(arr, length, breadth, height, volWeight);
        setidenticalShow(false);
        handleIdenticalReset()
    };

    const fillInitialData = (arr, length, breadth, height, volWeight) => {
        setFormData(prevFormData => {
            const updatedRows = [...prevFormData.weightDetail];

            // Find the index of the first unfilled row
            let startIndex = updatedRows.findIndex(row => !row.length && !row.breadth && !row.height && !row.volWeight);

            // If all rows are filled, startIndex will be -1, set it to 0
            if (startIndex === -1) startIndex = 0;

            // Fill rows starting from startIndex
            for (let i = startIndex; i < startIndex + arr; i++) {
                if (i < updatedRows.length) {
                    updatedRows[i] = {
                        ...updatedRows[i],
                        length: length,
                        breadth: breadth,
                        height: height,
                        volWeight: volWeight,
                    };
                }
            }

            return {
                ...prevFormData,
                weightDetail: updatedRows,
            };
        });
    };
    const handleNewArrayAddonChange = (event) => {
        const newNumRows = event.target.value; // This will be a string
        const newNumRowsInt = parseInt(newNumRows, 10); // Convert to integer for logic

        setRemainingDescClicks(newNumRowsInt);

        // Get the existing rows from formData
        const existingRows = formData.weightDetail || [];

        // Create new rows or truncate the existing ones
        let newRows;
        if (newNumRowsInt > existingRows.length) {
            // Add new empty rows
            newRows = [
                ...existingRows,
                ...Array.from({ length: newNumRowsInt - existingRows.length }, () => ({
                    weightDetailsID: '',
                    length: '',
                    breadth: '',
                    height: '',
                    volWeight: '',
                    packages: '',
                }))
            ];
        } else {
            // Keep only the first newNumRowsInt rows
            newRows = existingRows.slice(0, newNumRowsInt);
        }

        // Update formData state
        setFormData(prevFormData => ({
            ...prevFormData,
            totalPacket: newNumRows, // Store as string
            weightDetail: newRows,  // Update with the newRows
        }));
    };

    const [formData, setFormData] = useState({
        "packetID": "",
        "awbNo": "System-Generated",
        "referenceNumber": "",
        "bookingDate": formattedDate1,
        "cCode": "",
        "branchCode": Branchcode,
        "consignorCode": "",
        "consignorName": "",
        "consignorAddress1": "",
        "consignorAddress2": "",
        "consignorAddress3": "",
        "consignorCityCode": "",
        "consignorStateCode": "",
        "consignorCountryCode": "",
        "consignorZipCode": "",
        "consignorPhoneNo": "",
        "consignorEmailID": "",
        "consignorGSTIN": "",
        "consigneeCode": "",
        "consigneeName": "",
        "consigneeCPerson": "",
        "consigneeAddress1": "",
        "consigneeAddress2": "",
        "consigneeAddress3": "",
        "consigneeCityCode": "",
        "consigneeStateCode": "",
        "consigneeCountryCode": "",
        "consigneeZipCode": "",
        "consigneePhoneNo": "",
        "consigneeEmailID": "",
        "consigneeGSTIN": "",
        "consigneeICENo": "",
        "consigneePanNo": "",
        "totalPacket": "",
        "totalValue": "",
        "currencyName": "",
        "actualWeight": "",
        "weightUnit": "",
        "volumetricWeight": "",
        "chargedWeight": "",
        "perKGRate": "",
        "packetType": "",
        "paymentType": "",
        "codAmount": "",
        "codCurrency": "",
        "descTotalValue": "",
        "invoiceType": "",
        "type": "INS",
        "vendor": "",
        "airlineCode": "",
        "serviceType": "",
        "forwardingNo": "",
        "faCode": "",
        "hold": false,
        "holdDetails": "",
        "divisor": "5000",
        "isVolWeight": false,
        "weightDetail": [],

        "descriptionDetails": [
            {
                "descriptionDetailsID": "",
                "description": "",
                "units": "",
                "unitValue": "",
                "hsn": "",
                "total": ""
            }
        ]
    })

    const handleClear = () => {
        setFormData({
            "packetID": "",
            "awbNo": "",
            "referenceNumber": "",
            "bookingDate": formattedDate1,
            "cCode": "",
            "branchCode": Branchcode,
            "consignorCode": "",
            "consignorName": "",
            "consignorAddress1": "",
            "consignorAddress2": "",
            "consignorAddress3": "",
            "consignorCityCode": "",
            "consignorStateCode": "",
            "consignorCountryCode": "",
            "consignorZipCode": "",
            "consignorPhoneNo": "",
            "consignorEmailID": "",
            "consignorGSTIN": "",
            "consigneeCode": "",
            "consigneeName": "",
            "consigneeCPerson": "",
            "consigneeAddress1": "",
            "consigneeAddress2": "",
            "consigneeAddress3": "",
            "consigneeCityCode": "",
            "consigneeStateCode": "",
            "consigneeCountryCode": "",
            "consigneeZipCode": "",
            "consigneePhoneNo": "",
            "consigneeEmailID": "",
            "consigneeGSTIN": "",
            "consigneeICENo": "",
            "consigneePanNo": "",
            "totalPacket": "",
            "totalValue": "",
            "currencyName": "",
            "actualWeight": "",
            "weightUnit": "",
            "volumetricWeight": "",
            "chargedWeight": "",
            "perKGRate": "",
            "packetType": "",
            "paymentType": "",
            "codAmount": "",
            "codCurrency": "",
            "descTotalValue": "",
            "invoiceType": "",
            "type": "INS",
            "vendor": "",
            "airlineCode": "",
            "serviceType": "",
            "forwardingNo": "",
            "faCode": "",
            "hold": false,
            "holdDetails": "",
            "divisor": "5000",
            "isVolWeight": false,
            "weightDetail": [
                {
                    "weightDetailsID": "",
                    "length": "",
                    "breadth": "",
                    "height": "",
                    "volWeight": "",
                    "packages": ""
                }
            ],
            "descriptionDetails": [
                {
                    "descriptionDetailsID": "",
                    "description": "",
                    "units": "",
                    "unitValue": "",
                    "hsn": "",
                    "total": ""
                }
            ],
        });
        inputrefs.current['txtReferenceNumber'].focus();
    };
    const navigate = useNavigate()

    //const handleAdd = () => {

    //    if (Number(formData.totalPacket) === formData.weightDetail.length) {
    //        NotificationSound('ERROR', `You have  Selected only ${formData.totalPacket} Pieces!.`, '', '', '');
    //        return
    //    }
    //    if (Number(formData.totalPacket) !== formData.weightDetail.length) {
    //        let list = [...formData.weightDetail];
    //        list = [...list, {
    //            "weightDetailsID": '',
    //            "length": '',
    //            "breadth": '',
    //            "height": '',
    //            "volWeight": '',
    //            "packages": '',
    //        }];
    //        setFormData({ ...formData, weightDetail: list });
    //        setRemainingClicks(remainingClicks - 1);
    //    } else {
    //        NotificationSound('ERROR', `You have  Selected only ${formData.totalPacket} Pieces!.`, '', '', '');
    //    }
    //};


    const handleDelete = (index) => {
        if (formData.weightDetail.length <= 1) {
            return
        } else {
            let list = [...formData.weightDetail];
            list.splice(index, 1);
            setFormData({ ...formData, weightDetail: list });
        }
    };


    const handleAddDesc = () => {
        if (Number(formData.totalPacket) === formData?.descriptionDetails?.length) {
            NotificationSound('ERROR', `You have  Selected only ${formData.totalPacket} Pieces!.`, '', '', '');
            return
        }
        if (Number(formData.descTotalValue) < Number(formData.totalValue)) {
            if (Number(formData.totalPacket) !== formData.descriptionDetails.length) {
                let list = [...formData.descriptionDetails];
                list = [...list, {
                    "descriptionDetailsID": '',
                    "description": '',
                    "units": '',
                    "unitValue": '',
                    "hsNo": '',
                    "total": '',
                }];
                setFormData({ ...formData, descriptionDetails: list });
                setRemainingDescClicks(remainingDescClicks - 1);
            } else {
                NotificationSound('ERROR', `You have  Selected only ${formData.totalPacket} Pieces!.`, '', '', '');
            }
        } else {
            NotificationSound('ERROR', 'Desc Value should be less than total Value');
        }
    };

    const handleDeleteDesc = (index) => {
        if (formData.descriptionDetails.length <= 1) {
            return
        } else {
            let list = [...formData.descriptionDetails];
            list.splice(index, 1);
            setFormData({ ...formData, descriptionDetails: list });
        }
    };

    const GetPacketBookingData = async (value) => {
        setSubLoading(true)
        let data = await ApiCall('/api/Operation/GetPacketBookingData', { awbNo: value, PageType })
        let record = data.data;
        if (data.status === 'SUCCESS') {
            setFormData({ ...formData, ...record, type: PageType });
            setRemainingClicks(record.totalPacket)
            setRemainingDescClicks(record.totalPacket)
        }
    }



    //const getconsignordataResquet = async (value) => {
    //    const code = value.split(" : ")[0]
    //    let data = await ApiCall('/api/Operation/GetBookingConsignorDetails', { CCode: code, })
    //    setFormData({
    //        ...formData,
    //        consignorName: value,
    //        consignorAddress1: data.data.consignorAddress,
    //        consignorAddress2: data.data.consignorAddress1,
    //        consignorCityCode: data.data.consignorCity,
    //        consignorStateCode: data.data.consignorState,
    //        consignorCountryCode: data.data.consignorCountry,
    //        consignorZipCode: data.data.consignorPin,
    //        consignorPhoneNo: data.data.consignorPhone,
    //        consignorEmailID: data.data.consignorEmailID,
    //        consignorGSTIN: data.data.consignorGSTIN,

    //    });

    //}
    const getconsignordataResquet = async (value) => {
        if (!value || value.trim() === '') {
            // Clear all fields if the value is empty
            setFormData({
                ...formData,
                consignorName: '',
                consignorAddress1: '',
                consignorAddress2: '',
                consignorCityCode: '',
                consignorStateCode: '',
                consignorCountryCode: '',
                consignorZipCode: '',
                consignorPhoneNo: '',
                consignorEmailID: '',
                consignorGSTIN: '',
            });
            return;
        }

        const code = value.split(" : ")[0];
        let data = await ApiCall('/api/Operation/GetBookingConsignorDetails', { CCode: code });
        setFormData({
            ...formData,
            consignorName: value,
            consignorAddress1: data.data.consignorAddress,
            consignorAddress2: data.data.consignorAddress1,
            consignorCityCode: data.data.consignorCity,
            consignorStateCode: data.data.consignorState,
            consignorCountryCode: data.data.consignorCountry,
            consignorZipCode: data.data.consignorPin,
            consignorPhoneNo: data.data.consignorPhone,
            consignorEmailID: data.data.consignorEmailID,
            consignorGSTIN: data.data.consigneeGSTIN,
        });
    };

    //const getConsigneedataResquet = async (value) => {
    //    const code = value.split(" : ")[0]
    //    let data = await ApiCall('/api/Operation/GetBookingConsigneeDetails', { CCode: code, })
    //    setFormData({
    //        ...formData,
    //        consigneeName: value,
    //        consigneeAddress1: data.data.consigneeAddress,
    //        consigneeAddress2: data.data.consigneeddress1,
    //        consigneeCityCode: data.data.consigneeCity,
    //        consigneeStateCode: data.data.consigneeState,
    //        consigneeCountryCode: data.data.consigneeCountry,
    //        consigneeZipCode: data.data.consigneePin,
    //        consigneePhoneNo: data.data.consigneePhone,
    //        consigneeEmailID: data.data.consigneeEmailID,
    //        consigneeGSTIN: data.data.consigneeGSTIN,
    //        consigneeICENo: data.data.consigneeIEC,
    //        consigneePanNo: data.data.consigneePANNo,

    //    });

    //}
    const getConsigneedataResquet = async (value) => {
        if (!value || value.trim() === '') {
            // Clear all fields if the value is empty
            setFormData({
                ...formData,
                consigneeName: '',
                consigneeAddress1: '',
                consigneeAddress2: '',
                consigneeCityCode: '',
                consigneeStateCode: '',
                consigneeCountryCode: '',
                consigneeZipCode: '',
                consigneePhoneNo: '',
                consigneeEmailID: '',
                consigneeGSTIN: '',
            });
            return;
        }

        const code = value.split(" : ")[0];
        let data = await ApiCall('/api/Operation/GetBookingConsigneeDetails', { CCode: code });
        setFormData({
            ...formData,
            consigneeName: value,
            consigneeAddress1: data.data.consigneeAddress,
            consigneeAddress2: data.data.consigneeddress1,
            consigneeCityCode: data.data.consigneeCity,
            consigneeStateCode: data.data.consigneeState,
            consigneeCountryCode: data.data.consigneeCountry,
            consigneeZipCode: data.data.consigneePin,
            consigneePhoneNo: data.data.consigneePhone,
            consigneeEmailID: data.data.consigneeEmailID,
            consigneeGSTIN: data.data.consigneeGSTIN,
        });
    };
    const GetPaymentType = DropDownData('GetPaymentType')
    const GetCurrency = DropDownData('GetCurrency')
    const GetWeightUnit = DropDownData('GetWeightUnit')
    const GetPacketType = DropDownData('GetPacketType')

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/Operation/PacketBooking', formData)
        await dispatch(setSubLoading(false))
        if (data.status === 'ERROR' || data.status === 'EXPIRED' || data.status === 'UNAUTHORIZED' || data.status === 'SUCCESS') {
            await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);

        }
        if (data.status === 'SUCCESS') {
            navigate('/PacketBooking')
        }
    }

    let totalVolWgt = 0;
    for (let i = 0; i < formData.weightDetail.length; i++) {
        totalVolWgt += Number(formData.weightDetail[i].volWeight);
    }
    let descTotalValue = 0;
    for (let i = 0; i < formData.descriptionDetails.length; i++) {
        descTotalValue += Number(formData.descriptionDetails[i].total);
    }

    const autoCompleteTimeoutRef = useRef(null);
    const handleAutoCompleteChange = async (event, newValue, field, type) => {
        if (autoCompleteTimeoutRef.current) {
            clearTimeout(autoCompleteTimeoutRef.current);
        }
        if (event?.type === 'change') {
            autoCompleteTimeoutRef.current = setTimeout(async () => {
                const autoOptions = await FetchAutoCompleteData('', newValue, type, field);
                setAutoCompleteOptions(autoOptions ? autoOptions : []);
            }, autoCompleteDelay)
        }
    };

    useEffect(() => {
        setFormData(prevFormData => {
            const totalVolWgtString = totalVolWgt.toString();
            if (prevFormData.volumetricWeight !== totalVolWgtString) {
                return { ...prevFormData, volumetricWeight: totalVolWgtString };
            }
            return prevFormData;
        });
    }, [totalVolWgt]);

    useEffect(() => {
        setFormData(prevFormData => ({
            ...prevFormData,
            descTotalValue: convertThreeDecimalsOnValue(descTotalValue.toString())
        }));
    }, [descTotalValue]);

    useEffect(() => {
        if (Number(formData.actualWeight) > Number(formData.volumetricWeight)) {
            setFormData({ ...formData, chargedWeight: formData.actualWeight })
        } else {
            setFormData({ ...formData, chargedWeight: formData.volumetricWeight })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData.actualWeight, formData.volumetricWeight])


    useEffect(() => {
        inputrefs.current['txtReferenceNumber'].focus();
        document.title = 'Packet Booking'
        awbNo ? GetPacketBookingData(awbNo) : <></>
    }, [])

    return (
        <>
            <div className='main-card PickUp_Entry card border-0'>
                <div className='card-header mb-1'>
                    <span className="fs-6 fw-bold headingspan"> {FindTranslatedKey('Packet Booking')}</span>
                </div>
                <div className='card-body px-3'>
                    <div className="rounded py-1 px-2 mb-2 " style={{ boxShadow: 'rgba(101, 155, 242, 0.5) 0px 0px 5px', borderTop: "2px solid #f18282" }} >
                        <div className='row'>
                            <InputBox
                                label='AWB No'
                                PlaceHolderText='AWB No'
                                required={false}
                                inputrefs={inputrefs}
                                id='txtAwbNo'
                                value={formData.awbNo}
                                maxLength='20'
                                disabled
                                onChange={(event) => {
                                    setFormData({
                                        ...formData, awbNo: event.target.value
                                    })

                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtReferenceNumber'].focus();
                                    }
                                }}
                            />
                            <InputBox
                                label='Reference No '
                                PlaceHolderText='Reference No '
                                required={false}
                                inputrefs={inputrefs}
                                id='txtReferenceNumber'
                                value={formData.referenceNumber}
                                maxLength='20'
                                onChange={(e) => {
                                    setFormData({ ...formData, referenceNumber: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtbookingDate'].focus();
                                    }
                                }}
                            />
                            <DateBox
                                inputrefs={inputrefs}
                                label="Booking Date"
                                placeholder="Booking Date"
                                id='txtbookingDate'
                                // value={formData.bookingDate ? formData.bookingDate : ''}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtClient'].focus()
                                    };
                                }}
                                required={true}
                                selected={formData.bookingDate === '' ? '' : new Date(formData.bookingDate)}
                                onChange={(e) => handleDateChange(e, setFormData, formData, 'bookingDate')}
                            />
                            <AutoCompleteBox
                                label='Client'
                                placeholder='Client'
                                inputValue={formData.cCode}
                                options={autoCompleteOptions}
                                setOptions={setAutoCompleteOptions}
                                onInputChange={
                                    (event, newInputValue) => {
                                        handleAutoCompleteChange(event, newInputValue, bcode, 'GetClient');
                                        setFormData({ ...formData, cCode: newInputValue })
                                    }
                                }
                                inputrefs={inputrefs}
                                id='txtClient'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                        e.preventDefault()
                                        inputrefs.current['txtBranch'].focus()
                                    };
                                }}
                                required={true}
                            />
                            <AutoCompleteBox
                                label='Branch'
                                placeholder='Branch'
                                inputValue={formData.branchCode}
                                options={autoCompleteOptions}
                                setOptions={setAutoCompleteOptions}
                                onInputChange={
                                    (event, newInputValue) => {
                                        handleAutoCompleteChange(event, newInputValue, '', 'GetBranch');
                                        setFormData({ ...formData, branchCode: newInputValue })
                                    }
                                }
                                inputrefs={inputrefs}
                                id='txtBranch'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                        e.preventDefault()
                                        inputrefs.current['txtConsignorName'].focus()
                                    };
                                }}
                                required={true}
                            />
                        </div>
                    </div>
                    <div className='main-items-2 gap-1 d-flex my-2' >
                        <div className='items-2 rounded' style={{ borderTop: '2px solid var(--first_theme)' }}>
                            <div className='row my-1 justify-content-between' style={{ marginTop: '2px' }}>
                                <div className="col-lg-5 col-md-6  col-sm-12 pb-2 pe-2 pb-2"><h6 className='mb-0' style={{ fontSize: '12px' }}>{FindTranslatedKey('Consignor / Shipper')}</h6></div>
                            </div>
                            <div className='row'>
                                {/*<InputBox*/}
                                {/*    divclassname='col-sm-4 mb-1'*/}
                                {/*    id='txtConsignorName'*/}
                                {/*    onKeyDown={(e) => {*/}
                                {/*        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {*/}
                                {/*            e.preventDefault()*/}
                                {/*            inputrefs.current['txtConsignorEmailID'].focus()*/}
                                {/*        };*/}
                                {/*    }}*/}
                                {/*    inputrefs={inputrefs}*/}
                                {/*    required={true}*/}
                                {/*    label='Consignor Name'*/}
                                {/*    placeholder='Consignor Name'*/}
                                {/*    value={formData.consignorName}*/}
                                {/*    onChange={(e) => {*/}
                                {/*        setFormData({ ...formData, consignorName: e.target.value })*/}
                                {/*    }}*/}
                                {/*    maxLength='100'*/}
                                {/*/>*/}
                                <AutoCompleteBox
                                    divclassname='col-sm-4 mb-1'
                                    label='Consignor Name'
                                    placeholder='Consignor Name'
                                    required={true}
                                    inputValue={formData.consignorName}
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    onInputChange={
                                        (event, newInputValue) => {

                                            handleAutoCompleteChange(event, newInputValue, formData.cCode, 'GetConsignorBooking');
                                            setFormData({ ...formData, consignorName: newInputValue })
                                        }
                                    }

                                    onChange={(e, newInputValue) => {
                                        if (!newInputValue || newInputValue.trim() === '') {
                                            setFormData({
                                                ...formData,
                                                consignorName: '',
                                                consignorAddress1: '',
                                                consignorAddress2: '',
                                                consignorCityCode: '',
                                                consignorStateCode: '',
                                                consignorCountryCode: '',
                                                consignorZipCode: '',
                                                consignorPhoneNo: '',
                                                consignorEmailID: '',
                                                consignorGSTIN: '',
                                            });
                                        } else {
                                            getconsignordataResquet(newInputValue);
                                        }
                                    }}
                                    maxLength='100'
                                    inputrefs={inputrefs}
                                    id='txtConsignorName'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsignorEmailID'].focus()
                                        };
                                    }}

                                />

                                <InputBox
                                    divclassname='col-sm-4 mb-1'
                                    id='txtConsignorEmailID'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsignorPhoneNo'].focus()
                                        };
                                    }}
                                    inputrefs={inputrefs}
                                    label='Email ID'
                                    required={true}
                                    PlaceHolderText='Email ID'
                                    value={formData.consignorEmailID}
                                    onChange={(e) => {
                                        setFormData({ ...formData, consignorEmailID: e.target.value })
                                    }}
                                    maxLength='100'
                                />
                                <InputBox
                                    divclassname='col-sm-4 mb-1'
                                    id='txtConsignorPhoneNo'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsignorCountryCode'].focus()
                                        };
                                    }}
                                    inputrefs={inputrefs}
                                    label='Phone No'
                                    required={true}
                                    PlaceHolderText='Phone No'
                                    value={formData.consignorPhoneNo}
                                    onChange={(e) => {
                                        setFormData({ ...formData, consignorPhoneNo: convertToNumber(e.target.value) })
                                    }}
                                    maxLength='15'
                                />
                                <AutoCompleteBox
                                    divclassname='col-sm-4 mb-1'
                                    label='Country'
                                    placeholder='Country'
                                    required={true}
                                    inputValue={formData.consignorCountryCode}
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    onInputChange={
                                        (event, newInputValue) => {
                                            handleAutoCompleteChange(event, newInputValue, '', 'GetCountry');
                                            setFormData({ ...formData, consignorCountryCode: newInputValue, consignorStateCode: "", consignorCityCode: "" })
                                        }
                                    }
                                    inputrefs={inputrefs}
                                    id='txtConsignorCountryCode'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsignorStateCode'].focus()
                                        };
                                    }}
                                    maxLength='50'
                                />
                                <AutoCompleteBox
                                    divclassname='col-sm-4 mb-1'
                                    label='State'
                                    placeholder='State'
                                    inputValue={formData.consignorStateCode}
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    onInputChange={
                                        (event, newInputValue) => {
                                            handleAutoCompleteChange(event, newInputValue, formData.consignorCountryCode, 'GetState_CountryWise');
                                            setFormData({ ...formData, consignorStateCode: newInputValue })
                                        }
                                    }
                                    inputrefs={inputrefs}
                                    id='txtConsignorStateCode'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsignorCityCode'].focus()
                                        };
                                    }}
                                    // required={true}
                                    maxLength='50'
                                />
                                <AutoCompleteBox
                                    divclassname='col-sm-4 mb-1'
                                    label='City'
                                    placeholder='City'
                                    inputValue={formData.consignorCityCode}
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    onInputChange={
                                        (event, newInputValue) => {
                                            handleAutoCompleteChange(event, newInputValue, formData.consignorCountryCode, 'GetCity_CountryWise');
                                            setFormData({ ...formData, consignorCityCode: newInputValue })
                                        }
                                    }
                                    inputrefs={inputrefs}
                                    id='txtConsignorCityCode'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsignorZip'].focus()
                                        };
                                    }}
                                    //  required={true}
                                    maxLength='50'
                                />
                                <AutoCompleteBox
                                    divclassname='col-sm-4 mb-1'
                                    label='Zip'
                                    placeholder='Zip'
                                    inputValue={formData.consignorZipCode ? formData.consignorZipCode : ''}
                                    onInputChange={
                                        (event, newInputValue) => {
                                            handleAutoCompleteChange(event, newInputValue, formData.consignorCityCode, 'GetPinCode_CityWise');
                                            setFormData({ ...formData, consignorZipCode: newInputValue })
                                        }}
                                    maxLength='6'
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    inputrefs={inputrefs}
                                    id='txtConsignorZip'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current['txtConsignorAddress1'].focus() };
                                    }}
                                />
                                <InputBox
                                    divclassname='col-sm-4 mb-1'
                                    id='txtConsignorAddress1'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsignorAddress2'].focus()
                                        };
                                    }}
                                    inputrefs={inputrefs}
                                    label='Address 1'
                                    required={true}
                                    PlaceHolderText='Address 1'
                                    value={formData.consignorAddress1}
                                    onChange={(e) => {
                                        setFormData({ ...formData, consignorAddress1: e.target.value })
                                    }}
                                    maxLength='100'
                                />
                                <InputBox
                                    divclassname='col-sm-4 mb-1'
                                    id='txtConsignorAddress2'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsignorAddress3'].focus()
                                        };
                                    }}
                                    inputrefs={inputrefs}
                                    label='Address 2'
                                    PlaceHolderText='Address 2'
                                    value={formData.consignorAddress2}
                                    onChange={(e) => {
                                        setFormData({ ...formData, consignorAddress2: e.target.value })
                                    }}
                                    maxLength='100'
                                />
                                <InputBox
                                    divclassname='col-sm-4 mb-1'
                                    id='txtConsignorAddress3'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsignorGSTIN'].focus()
                                        };
                                    }}
                                    inputrefs={inputrefs}
                                    label='Address 3'
                                    PlaceHolderText='Address 3'
                                    value={formData.consignorAddress3}
                                    onChange={(e) => {
                                        setFormData({ ...formData, consignorAddress3: e.target.value })
                                    }}
                                    maxLength='100'
                                />
                                {/*<InputBox*/}
                                {/*    divclassname='col-sm-4 mb-1'*/}
                                {/*    inputclassname='p-1 form-control'*/}
                                {/*    id='txtConsignorZip'*/}
                                {/*    onKeyDown={(e) => {*/}
                                {/*        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {*/}
                                {/*            e.preventDefault()*/}
                                {/*            inputrefs.current['txtConsignorGSTIN'].focus()*/}
                                {/*        };*/}
                                {/*    }}*/}
                                {/*    inputrefs={inputrefs}*/}
                                {/*    label='Zip'*/}
                                {/*    placeholder='Zip'*/}
                                {/*    value={formData.consignorZipCode}*/}
                                {/*    onChange={(e) => {*/}
                                {/*        setFormData({ ...formData, consignorZipCode: e.target.value })*/}
                                {/*    }}*/}
                                {/*    maxLength='100'*/}
                                {/*/>*/}
                                <InputBox
                                    divclassname='col-sm-4 mb-1'
                                    inputclassname='p-1 form-control'
                                    id='txtConsignorGSTIN'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsigneeName'].focus()
                                        };
                                    }}
                                    inputrefs={inputrefs}
                                    label='GSTIN'
                                    PlaceHolderText='GSTIN'
                                    maxLength='10'
                                    value={formData.consignorGSTIN}
                                    onChange={(e) => {
                                        setFormData({ ...formData, consignorGSTIN: e.target.value })
                                    }}
                                />
                            </div>
                        </div>
                        <div className='items-2 rounded' style={{ borderTop: '2px solid var(--first_theme)' }}>
                            <div className='row my-1 justify-content-between' style={{ marginTop: '2px' }}>
                                <div className="col-lg-4 col-md-5  col-sm-12 pb-2 pe-2 pb-2"><h6 className='mb-0' style={{ fontSize: '12px' }}>{FindTranslatedKey('Consignee/Receiver ')}</h6></div>
                            </div>
                            <div className='row'>

                                <AutoCompleteBox
                                    divclassname='col-sm-4 mb-1'
                                    label='Consignee Name'
                                    placeholder='Consignee Name'
                                    required={true}
                                    inputValue={formData.consigneeName}
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    onInputChange={
                                        (event, newInputValue) => {

                                            handleAutoCompleteChange(event, newInputValue, formData.cCode, 'GetConsigneeBooking');
                                            setFormData({ ...formData, consigneeName: newInputValue })
                                        }
                                    }

                                    onChange={(e, newInputValue) => {
                                        if (!newInputValue || newInputValue.trim() === '') {

                                            setFormData({
                                                ...formData,
                                                consigneeName: '',
                                                consigneeAddress1: '',
                                                consigneeAddress2: '',
                                                consigneeCityCode: '',
                                                consigneeStateCode: '',
                                                consigneeCountryCode: '',
                                                consigneeZipCode: '',
                                                consigneePhoneNo: '',
                                                consigneeEmailID: '',
                                                consigneeGSTIN: '',
                                            });
                                        } else {
                                            getConsigneedataResquet(newInputValue);
                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    id='txtConsigneeName'
                                    maxLength='100'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsigneeCPerson'].focus()
                                        };
                                    }}

                                />

                                <InputBox
                                    divclassname='col-sm-4 mb-1'
                                    id='txtConsigneeCPerson'

                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsigneeEmailID'].focus()
                                        };
                                    }}
                                    inputrefs={inputrefs}
                                    label='Contact Person'
                                    PlaceHolderText='Contact Person'
                                    value={formData.consigneeCPerson}
                                    onChange={(e) => {
                                        setFormData({ ...formData, consigneeCPerson: e.target.value })
                                    }}
                                    maxLength='100'
                                />
                                <InputBox
                                    divclassname='col-sm-4 mb-1'
                                    id='txtConsigneeEmailID'
                                    // required={true}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsigneePhoneNo'].focus()
                                        };
                                    }}
                                    inputrefs={inputrefs}
                                    label='Email ID'
                                    PlaceHolderText='Email ID'
                                    value={formData.consigneeEmailID}
                                    onChange={(e) => {
                                        setFormData({ ...formData, consigneeEmailID: e.target.value })
                                    }}
                                    maxLength='100'
                                />
                                <InputBox
                                    divclassname='col-sm-4 mb-1'
                                    id='txtConsigneePhoneNo'
                                    required={true}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsigneeCountryCode'].focus()
                                        };
                                    }}
                                    inputrefs={inputrefs}
                                    label='Phone No'
                                    PlaceHolderText='Phone No'
                                    value={formData.consigneePhoneNo}
                                    onChange={(e) => {
                                        setFormData({ ...formData, consigneePhoneNo: convertToNumber(e.target.value) })
                                    }}
                                    maxLength='15'
                                />
                                <AutoCompleteBox
                                    divclassname='col-sm-4 mb-1'
                                    label='Country'
                                    placeholder='Country'
                                    inputValue={formData.consigneeCountryCode}
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    onInputChange={
                                        (event, newInputValue) => {
                                            handleAutoCompleteChange(event, newInputValue, '', 'GetCountry');
                                            setFormData({ ...formData, consigneeCountryCode: newInputValue, consigneeStateCode: "", consigneeCityCode: "" })
                                        }
                                    }
                                    inputrefs={inputrefs}
                                    id='txtConsigneeCountryCode'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsigneeStateCode'].focus()
                                        };
                                    }}
                                    required={true}
                                    maxLength='50'
                                />
                                <AutoCompleteBox
                                    divclassname='col-sm-4 mb-1'
                                    label='State'
                                    placeholder='State'
                                    inputValue={formData.consigneeStateCode}
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    onInputChange={
                                        (event, newInputValue) => {
                                            handleAutoCompleteChange(event, newInputValue, formData.consigneeCountryCode, 'GetState_CountryWise');
                                            setFormData({ ...formData, consigneeStateCode: newInputValue })
                                        }
                                    }
                                    inputrefs={inputrefs}
                                    id='txtConsigneeStateCode'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsigneeCityCode'].focus()
                                        };
                                    }}
                                    //   required={true}
                                    maxLength='50'
                                />
                                <AutoCompleteBox
                                    divclassname='col-sm-4 mb-1'
                                    label='City'
                                    placeholder='City'
                                    inputValue={formData.consigneeCityCode}
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    onInputChange={
                                        (event, newInputValue) => {
                                            handleAutoCompleteChange(event, newInputValue, formData.consigneeCountryCode, 'GetCity_CountryWise');
                                            setFormData({ ...formData, consigneeCityCode: newInputValue })
                                        }
                                    }
                                    inputrefs={inputrefs}
                                    id='txtConsigneeCityCode'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsigneeZipCode'].focus()
                                        };
                                    }}
                                    //   required={true}
                                    maxLength='50'
                                />
                                <AutoCompleteBox
                                    divclassname='col-sm-4 mb-1'
                                    label='Zip'
                                    placeholder='Zip'
                                    inputValue={formData.consigneeZipCode ? formData.consigneeZipCode : ''}
                                    onInputChange={
                                        (event, newInputValue) => {
                                            handleAutoCompleteChange(event, newInputValue, formData.consigneeCityCode, 'GetPinCode_CityWise');
                                            setFormData({ ...formData, consigneeZipCode: newInputValue })
                                        }}
                                    maxLength='6'
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    inputrefs={inputrefs}
                                    id='txtConsigneeZipCode'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current['txtConsigneeAddress1'].focus() };
                                    }}
                                />
                                <InputBox
                                    divclassname='col-sm-4 mb-1'
                                    id='txtConsigneeAddress1'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsigneeAddress2'].focus()
                                        };
                                    }}
                                    inputrefs={inputrefs}
                                    label='Address 1'
                                    required={true}
                                    PlaceHolderText='Address 1'
                                    value={formData.consigneeAddress1}
                                    onChange={(e) => {
                                        setFormData({ ...formData, consigneeAddress1: e.target.value })
                                    }}
                                    maxLength='100'
                                />
                                <InputBox
                                    divclassname='col-sm-4 mb-1'
                                    id='txtConsigneeAddress2'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsigneeAddress3'].focus()
                                        };
                                    }}
                                    inputrefs={inputrefs}
                                    label='Address 2'
                                    PlaceHolderText='Address 2'
                                    value={formData.consigneeAddress2}
                                    onChange={(e) => {
                                        setFormData({ ...formData, consigneeAddress2: e.target.value })
                                    }}
                                    maxLength='100'
                                />
                                <InputBox
                                    divclassname='col-sm-4 mb-1'
                                    id='txtConsigneeAddress3'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsigneeGSTIN'].focus()
                                        };
                                    }}
                                    inputrefs={inputrefs}
                                    label='Address 3'
                                    PlaceHolderText='Address 3'
                                    value={formData.consigneeAddress3}
                                    onChange={(e) => {
                                        setFormData({ ...formData, consigneeAddress3: e.target.value })
                                    }}
                                    maxLength='100'
                                />
                                {/*<InputBox*/}
                                {/*    divclassname='col-sm-4 mb-1'*/}
                                {/*    inputclassname='p-1 form-control'*/}
                                {/*    id='txtConsigneeZipCode'*/}
                                {/*    onKeyDown={(e) => {*/}
                                {/*        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {*/}
                                {/*            e.preventDefault()*/}
                                {/*            inputrefs.current['txtConsigneeGSTIN'].focus()*/}
                                {/*        };*/}
                                {/*    }}*/}
                                {/*    inputrefs={inputrefs}*/}
                                {/*    label='Zip'*/}
                                {/*    PlaceHolderText='Zip'*/}
                                {/*    value={formData.consigneeZipCode}*/}
                                {/*    onChange={(e) => {*/}
                                {/*        setFormData({ ...formData, consigneeZipCode: convertToNumber(e.target.value) })*/}
                                {/*    }}*/}
                                {/*    maxLength='6'*/}
                                {/*/>*/}
                                <InputBox
                                    divclassname='col-sm-4 mb-1'
                                    inputclassname='p-1 form-control'
                                    id='txtConsigneeGSTIN'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsigneeICENo'].focus()
                                        };
                                    }}
                                    inputrefs={inputrefs}
                                    label='GSTIN'
                                    PlaceHolderText='GSTIN'
                                    maxLength='15'
                                    value={formData.consigneeGSTIN}
                                    onChange={(e) => {
                                        setFormData({ ...formData, consigneeGSTIN: e.target.value })
                                    }}
                                />
                                <InputBox
                                    divclassname='col-sm-4 mb-1'
                                    inputclassname='p-1 form-control'
                                    id='txtConsigneeICENo'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsigneePanNo'].focus()
                                        };
                                    }}
                                    inputrefs={inputrefs}
                                    label='IEC No.'
                                    PlaceHolderText='IEC No.'
                                    maxLength='10'
                                    value={formData.consigneeICENo}
                                    onChange={(e) => {
                                        setFormData({ ...formData, consigneeICENo: e.target.value })
                                    }}
                                />
                                <InputBox
                                    divclassname='col-sm-4 mb-1'
                                    inputclassname='p-1 form-control'
                                    id='txtConsigneePanNo'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtvolumetric'].focus()
                                        };
                                    }}
                                    inputrefs={inputrefs}
                                    label='PAN No'
                                    PlaceHolderText='PAN No'
                                    maxLength='10'
                                    value={formData.consigneePanNo}
                                    onChange={(e) => {
                                        setFormData({ ...formData, consigneePanNo: e.target.value })
                                    }}
                                />

                            </div>
                        </div>
                    </div>
                    <div className="rounded-bottom py-1 px-2 mb-2 " style={{ boxShadow: 'rgba(101, 155, 242, 0.5) 0px 0px 5px', borderTop: "2px solid #ff5b5c" }} >
                        <div className='mb-1 d-flex package-card alighn-items-center gap-1'>
                            <div className=" pe-4"><h6 className='mb-0'>{FindTranslatedKey('Weight Details')} </h6></div>
                            <div className='d-flex gap-2 CN' style={{ marginTop: '-5px' }}>
                                <input
                                    className='form-check-input'
                                    type='checkbox'
                                    ref={ref => (inputrefs.current['txtvolumetric'] = ref)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault();
                                            inputrefs.current['txtPieces'].focus()
                                        };
                                    }}
                                    id='txtvolumetric'
                                    checked={formData.isVolWeight}
                                    onChange={(e) => {
                                        let checkValue = e.target.checked;

                                        setFormData({ ...formData, isVolWeight: checkValue, });

                                    }}
                                />
                                <label className='mt-1' htmlFor='txtvolumetric'>{FindTranslatedKey('Identical')}</label>
                                {formData.isVolWeight === true ? <>  <IoAddCircleSharp className='mt-1 pointereye' style={{ color: "#78A8FE" }} onClick={() => handleOpenIdentical()} /></> : <></>}
                            </div>
                        </div>
                        <div className='row'>
                            <InputBox
                                label='Pieces'
                                PlaceHolderText='Pieces'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtPieces'
                                value={formData.totalPacket}
                                maxLength='10'
                                onChange={handleNewArrayAddonChange}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtTotalValue'].focus();
                                    }
                                }}
                            />
                            <InputBox
                                label='Total value'
                                PlaceHolderText='Total Value'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtTotalValue'
                                value={formData.totalValue}
                                maxLength='100'
                                onChange={(e) => {
                                    setFormData({ ...formData, totalValue: convertTwoDecimalsOnValue(e.target.value) })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtCurrencyName'].focus();
                                    }
                                }}
                            />
                            <SelectInputBox
                                required={true}
                                label='Currency'
                                inputrefs={inputrefs}
                                id='txtCurrencyName'
                                value={formData.currencyName}
                                onChange={async (e) => {
                                    setFormData({ ...formData, currencyName: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtActualWeight'].focus();
                                    }
                                }}
                            >
                                <option value=''>{`--${FindTranslatedKey('Select')}--`}</option>
                                {GetCurrency?.data?.dataList?.map((item, index) =>
                                    <option key={item.name + index} value={item.name}>{FindTranslatedKey(item.name)}</option>
                                )}
                            </SelectInputBox>
                            <InputBox
                                label='Actual Weight'
                                PlaceHolderText='Actual Weight'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtActualWeight'
                                value={formData.actualWeight}
                                maxLength='100'
                                onChange={(e) => {
                                    setFormData({ ...formData, actualWeight: convertThreeDecimalsOnValue(e.target.value) })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtWeightUnit'].focus();
                                    }
                                }}
                            />
                            <SelectInputBox
                                label='Weight Unit'
                                placeholder='Weight Unit'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtWeightUnit'
                                value={formData.weightUnit}
                                onChange={(e) => {
                                    setFormData({ ...formData, weightUnit: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        if (formData.isVolWeight === true) {
                                            inputrefs.current['txtLength1'].focus();
                                        } else {
                                            inputrefs.current['txtPacketType'].focus();
                                        }

                                    }
                                }}
                            >
                                <option value=''>{`--${FindTranslatedKey('Select')}--`}</option>
                                {GetWeightUnit?.data?.dataList?.map((item, index) =>
                                    <option key={item.name + index} value={item.name}>{FindTranslatedKey(item.name)}</option>
                                )}
                            </SelectInputBox>

                        </div>
                        {Number(formData.totalPacket) >= 1 &&
                            <div className='mt-2'>
                                <div className=' card mb-2 border-0' >
                                    <div className='card-header p-0' >
                                        <div className='card-body' style={{ padding: '0px' }}>
                                            <div className="table-responsive">
                                                <table className="table border mb-0">
                                                    <thead>
                                                        <tr className='light-bg'>
                                                            <th style={{ padding: '5px 4px', width: "0rem" }}>{FindTranslatedKey('Del')}</th>
                                                            <th style={{ padding: '5px 5px' }}>{FindTranslatedKey('Length')} <span style={{ color: "red" }}> *</span></th>
                                                            <th style={{ padding: '5px 5px' }}>{FindTranslatedKey('Width')} <span style={{ color: "red" }}> *</span></th>
                                                            <th style={{ padding: '5px 5px' }}>{FindTranslatedKey('Height')} <span style={{ color: "red" }}> *</span></th>
                                                            <th style={{ padding: '5px 5px' }}>{FindTranslatedKey('Volume Wgt')}</th>
                                                            {/*  <th style={{ padding: '5px 5px', width: "0rem" }}>Add</th>*/}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {formData?.weightDetail?.map((item, index) =>
                                                            <tr key={`packageDetailsList${index + 1}`} className="TableTrhover" >
                                                                <td className='' style={{ minWidth: "10px" }} >
                                                                    {<span style={{ marginLeft: "-2px" }} >
                                                                        <i className="fa-regular fa-trash-can text-danger me-3 text-center "
                                                                            onClick={() => handleDelete(index)}
                                                                            style={{ marginLeft: "0px", marginTop: "4px", paddingRight: "0px" }}
                                                                        />
                                                                    </span>}
                                                                </td>
                                                                <td className='p-1'>
                                                                    <input
                                                                        placeholder={FindTranslatedKey('Length')}
                                                                        className='form-control w-100 '
                                                                        value={item.length}
                                                                        maxLength='10'
                                                                        ref={ref => (inputrefs.current[`txtLength${index + 1}`] = ref)}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                                                e.preventDefault();
                                                                                inputrefs.current[`txtWidth${index + 1}`].focus()
                                                                            };
                                                                        }}
                                                                        onChange={(e) => {
                                                                            let length = e.target.value;
                                                                            let breadth = Number(item.breadth)
                                                                            let height = Number(item.height)
                                                                            let volWgt = (Number(length) * breadth * height) / Number(formData.divisor);
                                                                            volWgt = (volWgt).toString()
                                                                            let list = [...formData.weightDetail];
                                                                            list[index] = { ...list[index], length: convertThreeDecimalsOnValue(length), volWeight: volWgt ? convertThreeDecimalsOnValue(volWgt) : '' }
                                                                            setFormData({ ...formData, weightDetail: list });
                                                                        }}
                                                                        onFocus={(e) => e.target.select()}
                                                                    />
                                                                </td>
                                                                <td className='p-1'>
                                                                    <input
                                                                        className='form-control w-100 '
                                                                        value={item.breadth}
                                                                        placeholder={FindTranslatedKey('Width')}
                                                                        maxLength='10'
                                                                        ref={ref => (inputrefs.current[`txtWidth${index + 1}`] = ref)}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                                                e.preventDefault();
                                                                                inputrefs.current[`txtHeight${index + 1}`].focus()
                                                                            };
                                                                        }}
                                                                        onChange={(e) => {
                                                                            let breadth = e.target.value;
                                                                            let length = Number(item.length)
                                                                            let height = Number(item.height)
                                                                            let volWgt = (Number(length) * breadth * height) / Number(formData.divisor)
                                                                            volWgt = (volWgt).toString()
                                                                            let list = [...formData.weightDetail];
                                                                            list[index] = { ...list[index], breadth: convertThreeDecimalsOnValue(breadth), volWeight: volWgt ? convertThreeDecimalsOnValue(volWgt) : '' }
                                                                            setFormData({ ...formData, weightDetail: list });
                                                                        }}
                                                                        onFocus={(e) => e.target.select()}
                                                                    />
                                                                </td>
                                                                <td className='p-1'>
                                                                    <input
                                                                        className='form-control w-100 '
                                                                        value={item.height}
                                                                        maxLength='10'
                                                                        placeholder={FindTranslatedKey('Height')}
                                                                        ref={ref => (inputrefs.current[`txtHeight${index + 1}`] = ref)}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                                                e.preventDefault();
                                                                                const nextIndex = index + 1;
                                                                                if (formData.weightDetail[nextIndex]) {
                                                                                    inputrefs.current[`txtLength${nextIndex + 1}`].focus();
                                                                                }
                                                                                else {
                                                                                    inputrefs.current['txtPacketType'].focus();
                                                                                }
                                                                            }
                                                                        }}
                                                                        onChange={(e) => {
                                                                            let height = e.target.value;
                                                                            let length = Number(item.length)
                                                                            let breadth = Number(item.breadth)
                                                                            let volWgt = (Number(length) * breadth * height) / Number(formData.divisor)
                                                                            volWgt = (volWgt).toString()
                                                                            let list = [...formData.weightDetail];
                                                                            list[index] = { ...list[index], height: convertThreeDecimalsOnValue(height), volWeight: volWgt ? convertThreeDecimalsOnValue(volWgt) : '' }
                                                                            setFormData({ ...formData, weightDetail: list });
                                                                        }}
                                                                        onFocus={(e) => e.target.select()}
                                                                    />
                                                                </td>
                                                                <td className='p-1'>
                                                                    <input
                                                                        className='form-control w-100 '
                                                                        value={item.volWeight}
                                                                        maxLength='10'
                                                                        placeholder={FindTranslatedKey('Volume Wgt')}
                                                                        ref={ref => (inputrefs.current[`txtVolWeight${index + 1}`] = ref)}
                                                                        disabled
                                                                    />
                                                                </td>
                                                                {/*<td className='p-1'>*/}
                                                                {/*    */}{/*{<span>*/}
                                                                {/*    */}{/*    <i className="fa-solid fa-circle-plus mt-1 text-success me-2"*/}
                                                                {/*    */}{/*        onClick={() => handleAdd(index)}*/}
                                                                {/*    */}{/*    />*/}
                                                                {/*    */}{/*</span>}*/}
                                                                {/*    {formData.weightDetail.length - 1 === index && < span >*/}
                                                                {/*        <i className="fa-solid fa-circle-plus mt-1 text-success me-2"*/}
                                                                {/*            onClick={() => handleAdd(index)}*/}
                                                                {/*        />*/}
                                                                {/*    </span>}*/}
                                                                {/*</td>*/}
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className='row'>
                            <InputBox
                                label='Total Weight'
                                divclassname='col-sm-3'
                                PlaceHolderText='Total Weight'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtTotalWeight'
                                value={formData.actualWeight}
                                maxLength='10'
                                disabled={true}
                            />
                            <InputBox
                                label='Total Volumetric Weight'
                                divclassname='col-sm-3'
                                PlaceHolderText='Total Volumetric Weight'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtTotalWeight'
                                value={formData.volumetricWeight}
                                maxLength='10'
                                disabled={true}
                            />
                            <InputBox
                                label='Total Charge Weight'
                                divclassname='col-sm-3'
                                PlaceHolderText='Total Charge Weight'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtTotalWeight'
                                value={formData.chargedWeight}
                                maxLength='10'
                                disabled={true}
                            />

                            {Hidesfield ? <> <InputBox
                                label='Rate/Kg'
                                divclassname='col-sm-3'
                                PlaceHolderText='Rate/Kg'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtPerKGRate'
                                value={formData.perKGRate}
                                onChange={(e) => setFormData({ ...formData, perKGRate: convertTwoDecimalsOnValue(e.target.value) })}
                                maxLength='10'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtPacketType'].focus();
                                    }
                                }}
                            /></> : <></>}


                        </div>
                    </div>
                    <div className='mb-2 main_card border-0'>
                        <div className='package-card other_details' >
                            <div className='grn-card-item' style={{ borderColor: '#0d8d0d' }}>
                                <div className='w-100 d-flex'>
                                    <h6 className='mb-0 mt-1'>{FindTranslatedKey('Packet Details')}</h6>
                                </div>
                                <div className='row other_cn_details mt-1'>
                                    <SelectInputBox
                                        label='Packet Type'
                                        required={true}
                                        inputrefs={inputrefs}
                                        id='txtPacketType'
                                        value={formData.packetType}
                                        onChange={(e) => {
                                            setFormData({ ...formData, packetType: e.target.value })
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtPaymentType'].focus();
                                            }
                                        }}
                                    >
                                        <option value=''>{`--${FindTranslatedKey('Select')}--`}</option>
                                        {GetPacketType?.data?.dataList?.map((item, index) =>
                                            <option key={item.name + index} value={item.name}>{FindTranslatedKey(item.name)}</option>
                                        )}
                                    </SelectInputBox>
                                    <SelectInputBox
                                        label='Payment Type'
                                        required={true}
                                        inputrefs={inputrefs}
                                        id='txtPaymentType'
                                        value={formData.paymentType}
                                        onChange={(e) => {
                                            setFormData({ ...formData, paymentType: e.target.value })
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                (formData.paymentType === 'COD' || formData.paymentType === 'CASH') ?
                                                    inputrefs.current['txtCODAmount'].focus() :
                                                    inputrefs.current['txtDescription1'].focus();
                                            }
                                        }}
                                    >
                                        <option value=''>{`--${FindTranslatedKey('Select')}--`}</option>
                                        {GetPaymentType?.data?.dataList?.map((item, index) =>
                                            <option key={item.name + index} value={item.name}>{FindTranslatedKey(item.name)}</option>
                                        )}
                                    </SelectInputBox>
                                    {(formData.paymentType === 'COD') && <>
                                        <InputBox
                                            label='COD Amount'
                                            PlaceHolderText='COD Amount'
                                            required={true}
                                            inputrefs={inputrefs}
                                            id='txtCODAmount'
                                            value={formData.codAmount}
                                            maxLength='10'
                                            onChange={(e) => {
                                                setFormData({ ...formData, codAmount: convertTwoDecimalsOnValue(e.target.value) })
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    inputrefs.current['txtCODCurrency'].focus();
                                                }
                                            }}
                                        />


                                        <SelectInputBox
                                            label='COD Currency'
                                            placeholder='COD Currency'
                                            required={true}
                                            inputrefs={inputrefs}
                                            id='txtCODCurrency'
                                            value={formData.codCurrency}
                                            onChange={(e) => {
                                                setFormData({ ...formData, codCurrency: e.target.value })
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    inputrefs.current['txtDescription1'].focus();
                                                }
                                            }}
                                        >
                                            <option value=''>{`--${FindTranslatedKey('Select')}--`}</option>
                                            {GetCurrency?.data?.dataList?.map((item, index) =>
                                                <option key={item.name + index} value={item.name}>{FindTranslatedKey(item.name)}</option>
                                            )}
                                        </SelectInputBox>
                                    </>}
                                    <InputBox
                                        label='Desc Total Value'
                                        PlaceHolderText='Desc Total Value'
                                        inputrefs={inputrefs}
                                        id='txtDescTotalValue'
                                        value={formData.descTotalValue}
                                        disabled={true}
                                    />
                                </div>
                                <div className='mt-2'>
                                    <div className=' card mb-2 border-0' >
                                        <div className='card-header p-0' >
                                            <div className='card-body' style={{ padding: '0px' }}>
                                                <div className="table-responsive">
                                                    <table className="table border mb-0">
                                                        <thead>
                                                            <tr className='light-bg'>
                                                                <th style={{ padding: '5px 4px', width: "0rem" }}>{FindTranslatedKey('Del')}</th>
                                                                <th style={{ padding: '5px 5px' }}> {FindTranslatedKey('Description')} <span style={{ color: "red" }}> *</span></th>
                                                                <th style={{ padding: '5px 5px' }}> {FindTranslatedKey('hsno')}</th>
                                                                <th style={{ padding: '5px 5px' }}> {FindTranslatedKey('Unit')} <span style={{ color: "red" }}> *</span></th>
                                                                <th style={{ padding: '5px 5px' }}> {FindTranslatedKey('Unit Value')} <span style={{ color: "red" }}> *</span></th>
                                                                <th style={{ padding: '5px 5px' }}> {FindTranslatedKey('Total')} <span style={{ color: "red" }}> *</span></th>
                                                                <th style={{ padding: '5px 5px', width: "0rem" }}> {FindTranslatedKey('Add')}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {formData?.descriptionDetails?.map((item, index) =>
                                                                <tr key={`packageDetailsList${index + 1}`} className="TableTrhover" >
                                                                    <td className='' style={{ minWidth: "10px" }} >
                                                                        {<span style={{ marginLeft: "-2px" }} >
                                                                            <i className="fa-regular fa-trash-can text-danger me-3 text-center "
                                                                                onClick={() => handleDeleteDesc(index)}
                                                                                style={{ marginLeft: "0px", marginTop: "4px", paddingRight: "0px" }}
                                                                            />
                                                                        </span>}
                                                                    </td>
                                                                    <td className='p-1'>
                                                                        <input
                                                                            placeholder={FindTranslatedKey('Description')}
                                                                            className='form-control w-100'
                                                                            id={`txtDescription${index + 1}`}
                                                                            value={item.description}
                                                                            maxLength='150'
                                                                            ref={ref => (inputrefs.current[`txtDescription${index + 1}`] = ref)}
                                                                            onKeyDown={(e) => {
                                                                                if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                                                    e.preventDefault(); inputrefs.current[`txtHsNo${index + 1}`].focus()
                                                                                };
                                                                            }}
                                                                            onChange={(e) => {
                                                                                let decs = e.target.value
                                                                                let list = [...formData.descriptionDetails];
                                                                                list[index] = { ...list[index], description: decs }
                                                                                setFormData({ ...formData, descriptionDetails: list });
                                                                            }}
                                                                            onFocus={(e) => e.target.select()}
                                                                        />
                                                                    </td>
                                                                    <td className='p-1'>
                                                                        <input
                                                                            placeholder={FindTranslatedKey('hsno')}
                                                                            className='form-control w-100'
                                                                            value={item.hsn}
                                                                            maxLength='150'
                                                                            ref={ref => (inputrefs.current[`txtHsNo${index + 1}`] = ref)}
                                                                            onKeyDown={(e) => {
                                                                                if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                                                    e.preventDefault();
                                                                                    inputrefs.current[`txtUnit${index + 1}`].focus()
                                                                                };
                                                                            }}
                                                                            onChange={(e) => {
                                                                                let hsn = e.target.value
                                                                                let list = [...formData.descriptionDetails];
                                                                                list[index] = { ...list[index], hsn: hsn }
                                                                                setFormData({ ...formData, descriptionDetails: list });
                                                                            }}
                                                                            onFocus={(e) => e.target.select()}
                                                                        />
                                                                    </td>
                                                                    <td className='p-1'>
                                                                        <input
                                                                            className='form-control w-100 '
                                                                            value={item.units}
                                                                            placeholder={FindTranslatedKey('Unit')}
                                                                            maxLength='10'
                                                                            ref={ref => (inputrefs.current[`txtUnit${index + 1}`] = ref)}
                                                                            onKeyDown={(e) => {
                                                                                if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                                                    e.preventDefault();
                                                                                    inputrefs.current[`txtUnitValue${index + 1}`].focus()
                                                                                };
                                                                            }}
                                                                            onChange={(e) => {
                                                                                let units = e.target.value;
                                                                                let unitValue = item.unitValue;
                                                                                let total = Number(units) * Number(unitValue)
                                                                                let list = [...formData.descriptionDetails];
                                                                                list[index] = {
                                                                                    ...list[index],
                                                                                    units: convertToNumber(units),
                                                                                    total: total.toString()
                                                                                }
                                                                                setFormData({ ...formData, descriptionDetails: list });
                                                                            }}
                                                                            onFocus={(e) => e.target.select()}
                                                                        />
                                                                    </td>
                                                                    <td className='p-1'>
                                                                        <input
                                                                            className='form-control w-100 '
                                                                            value={item.unitValue}
                                                                            maxLength='10'
                                                                            placeholder={FindTranslatedKey('Unit Value')}
                                                                            ref={ref => (inputrefs.current[`txtUnitValue${index + 1}`] = ref)}
                                                                            onKeyDown={(e) => {
                                                                                if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                                                    e.preventDefault();
                                                                                    const nextIndex = index + 1;
                                                                                    if (formData.descriptionDetails[nextIndex]) {
                                                                                        inputrefs.current[`txtDescription${nextIndex + 1}`].focus();
                                                                                    }
                                                                                    else {
                                                                                        inputrefs.current[`txtVendor`].focus()
                                                                                    }
                                                                                }
                                                                            }}
                                                                            onChange={(e) => {
                                                                                let unitValue = e.target.value;
                                                                                let units = item.units;
                                                                                let total = Number(units) * Number(unitValue)
                                                                                let list = [...formData.descriptionDetails];
                                                                                list[index] = {
                                                                                    ...list[index],
                                                                                    unitValue: convertThreeDecimalsOnValue(unitValue),
                                                                                    total: total.toString()
                                                                                }
                                                                                setFormData({ ...formData, descriptionDetails: list });
                                                                            }}
                                                                            onFocus={(e) => e.target.select()}
                                                                        />
                                                                    </td>
                                                                    <td className='p-1'>
                                                                        <input
                                                                            className='form-control w-100 '
                                                                            value={item.total}
                                                                            maxLength='10'
                                                                            placeholder={FindTranslatedKey('Total')}
                                                                            ref={ref => (inputrefs.current[`txtTotal${index + 1}`] = ref)}
                                                                            id={`txtTotal${index + 1}`}
                                                                            disabled
                                                                        />
                                                                    </td>
                                                                    <td className='p-1'>
                                                                        {formData.descriptionDetails.length - 1 === index && < span >
                                                                            <i className="fa-solid fa-circle-plus mt-1 text-success me-2"
                                                                                onClick={() => {
                                                                                    handleAddDesc(index)
                                                                                }}
                                                                            />
                                                                        </span>}
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='mb-2 fowarding_card border-0'>
                        <div className='package-card hold_details' >
                            <div className='purple-card-item' style={{ borderColor: '#0d8d0d' }}>
                                <div className='w-100 d-flex'>
                                    <h6 className='mb-0 mt-1'> {FindTranslatedKey('Forwording/Hold Details')}</h6>
                                </div>
                                <div className='row other_cn_details mt-1'>
                                    <AutoCompleteBox
                                        label='Vendor'
                                        placeholder='Vendor'
                                        inputValue={formData.vendor}
                                        options={autoCompleteOptions}
                                        setOptions={setAutoCompleteOptions}
                                        onInputChange={
                                            (event, newInputValue) => {
                                                handleAutoCompleteChange(event, newInputValue, '', 'GetVendor');
                                                setFormData({ ...formData, vendor: newInputValue })
                                            }
                                        }
                                        inputrefs={inputrefs}
                                        id='txtVendor'
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                e.preventDefault()
                                                inputrefs.current['txtAirlineCode'].focus()
                                            };
                                        }}
                                        required={false}
                                    />
                                    <InputBox
                                        label='Airline Code'
                                        PlaceHolderText='Airline Code'
                                        required={false}
                                        inputrefs={inputrefs}
                                        id='txtAirlineCode'
                                        value={formData.airlineCode}
                                        maxLength='50'
                                        onChange={(e) => {
                                            setFormData({ ...formData, airlineCode: e.target.value })
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtServiceType'].focus();
                                            }
                                        }}
                                    />
                                    <InputBox
                                        label='Service Type'
                                        PlaceHolderText='Service Type'
                                        required={false}
                                        inputrefs={inputrefs}
                                        id='txtServiceType'
                                        value={formData.serviceType}
                                        maxLength='50'
                                        onChange={(e) => {
                                            setFormData({ ...formData, serviceType: e.target.value })
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtForwardingNo'].focus();
                                            }
                                        }}
                                    />
                                    <InputBox
                                        label='Forwarding No.'
                                        PlaceHolderText='Forwarding No.'
                                        required={false}
                                        inputrefs={inputrefs}
                                        id='txtForwardingNo'
                                        value={formData.forwardingNo}
                                        maxLength='30'
                                        onChange={(e) => {
                                            setFormData({ ...formData, forwardingNo: e.target.value })
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtFaCode'].focus();
                                            }
                                        }}
                                    />
                                    <InputBox
                                        label='FA Code'
                                        PlaceHolderText='FA Code.'
                                        required={false}
                                        inputrefs={inputrefs}
                                        id='txtFaCode'
                                        value={formData.faCode}
                                        maxLength='30'
                                        onChange={(e) => {
                                            setFormData({ ...formData, faCode: e.target.value })
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtHold'].focus();
                                            }
                                        }}
                                    />
                                    <div className='d-flex gap-2'>
                                        <input
                                            className='form-check-input'
                                            type='checkbox'
                                            ref={ref => (inputrefs.current['txtHold'] = ref)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                    e.preventDefault();
                                                    if (formData.hold === true) {
                                                        inputrefs.current['txtHoldDetails'].focus()
                                                    } else {
                                                        inputrefs.current['btnSave'].focus()
                                                    }

                                                };
                                            }}
                                            id='txtHold'
                                            checked={formData.hold}
                                            onChange={(e) => {
                                                let checkValue = e.target.checked;
                                                setFormData({ ...formData, hold: checkValue })
                                            }}
                                        />
                                        <label className='mt-2' htmlFor='txtHold'>{FindTranslatedKey('Hold')}</label>
                                    </div>
                                    {formData.hold &&
                                        <div className='mt-2'>
                                            <InputBox
                                                label='Hold Details'
                                                PlaceHolderText='Hold Details'
                                                required={false}
                                                inputrefs={inputrefs}
                                                id='txtHoldDetails'
                                                value={formData.holdDetails}
                                                maxLength='10'
                                                onChange={(e) => {
                                                    setFormData({ ...formData, holdDetails: e.target.value })
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputrefs.current['btnSave'].focus();
                                                    }
                                                }}
                                            />
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <FormButton
                            id='btnSave'
                            inputrefs={inputrefs}
                            handleSubmit={handleSubmit}
                            Export={false}
                            handleClear={handleClear} />
                    </div>
                </div>
            </div>

            < Modal
                show={identicalShow} onHide={handleModalIdenticalShowClose}
                size="lg"

                keyboard={false}
                contentClassName='modaldashboard'

            >
                <Modal.Header closeButton >
                    <Modal.Title >
                        {FindTranslatedKey(' Weight Details')}

                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <InputBox
                            divclassname='col-md-2 col-sm-6'
                            label='Length'
                            PlaceHolderText='Length'
                            labelclass='mt-1'
                            inputrefs={inputrefs}
                            id='txtIdenticalLenght'
                            value={identicalForm.identicalLenght}
                            maxLength='10'
                            onChange={(e) => handleChangeIdentical('identicalLenght', convertThreeDecimalsOnValue(e.target.value))}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtIdenticalWidth'].focus();
                                }
                            }}
                        />
                        <InputBox
                            divclassname='col-md-2 col-sm-6'
                            label='Width'
                            labelclass='mt-1'
                            PlaceHolderText='Width'
                            inputrefs={inputrefs}
                            id='txtIdenticalWidth'
                            value={identicalForm.identicalWidht}
                            maxLength='10'
                            onChange={(e) => handleChangeIdentical('identicalWidht', convertThreeDecimalsOnValue(e.target.value))}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtIdenticalHeight'].focus();
                                }
                            }}
                        />
                        <InputBox
                            divclassname='col-md-2 col-sm-6'
                            label='Height'
                            PlaceHolderText='Height'
                            labelclass='mt-1'
                            inputrefs={inputrefs}
                            id='txtIdenticalHeight'
                            value={identicalForm.identicalHeight}
                            maxLength='10'
                            onChange={(e) => handleChangeIdentical('identicalHeight', convertThreeDecimalsOnValue(e.target.value))}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtidenticalpieces'].focus();
                                }
                            }}
                        />
                        <InputBox
                            divclassname='col-md-2 col-sm-6'
                            label='Vol Weight'
                            PlaceHolderText='Vol Weight'
                            labelclass='mt-1'
                            inputrefs={inputrefs}
                            id='txtIdenticalVolWeight'
                            disabled
                            value={identicalForm.identicalVol}
                            maxLength='50'
                            onChange={(e) => handleChangeIdentical('identicalVol', e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtidenticalpieces'].focus();
                                }
                            }}
                        />
                        <InputBox
                            divclassname='col-md-2 col-sm-6'
                            label='No. of PKG'
                            PlaceHolderText='No. of PKG'
                            labelclass='mt-1'
                            inputrefs={inputrefs}
                            id='txtidenticalpieces'
                            value={identicalForm.identicalpieces}
                            maxLength='10'
                            onChange={(e) => handleChangeIdentical('identicalpieces', e.target.value)}

                        />

                        <div className='col-md-2 col-sm-6 d-flex gap-1 align-items-center mt-4'>
                            <RiAddBoxFill style={{ fontSize: "30px", color: "green", cursor: "pointer" }} onClick={handleIdentical} />
                            <GrPowerReset style={{ fontSize: "28px", color: "red", cursor: "pointer" }} onClick={handleIdenticalReset} />
                        </div>


                    </div>
                </Modal.Body>
                <Modal.Footer>

                </Modal.Footer>
            </Modal >
        </>
    )
}
export default PacketBooking;